import { DateTime } from "luxon";
import { createColumnHelper } from "@tanstack/react-table";

import PagedTable from "../shared/Tables/PagedTable";
import formatDateTime from "../../utils/formatDateTime";
import { ILead, LeadStatus } from "../../models/Lead";
import ContactFromId from "../contacts/ContactFromId";

const colHelper = createColumnHelper<ILead>();

const formatCellDate = (dateValue?: string | null) => {
  if (!dateValue) return "Unknown";
  return formatDateTime(dateValue, DateTime.DATETIME_SHORT);
};

export default function DeletedLeadsTable() {
  const columns = [
    colHelper.accessor("deleted", {
      header: "Deleted On",
      id: "deleted",
      sortingFn: "auto",
      cell: (info) => formatCellDate(info.getValue()),
    }),
    colHelper.accessor("deletedBy", {
      header: "Deleted By",
      id: "deletedByName",
      sortingFn: "auto",
      cell: (info) => <ContactFromId contactId={info.getValue() ?? ""} />,
    }),
    colHelper.accessor("contact.fullname", {
      header: "Customer",
      id: "contactName",
      sortingFn: "auto",
      cell: (info) => (
        <div>
          <p>{info.getValue() || "Unknown"}</p>
          <p className="text-gray-500">{info.row.original.contact?.telephone1 || "-"}</p>
        </div>
      ),
    }),
    colHelper.accessor("vehicle.vrm", {
      header: "Vehicle",
      id: "vehicleVrm",
      sortingFn: "auto",
      cell: (info) => (
        <div>
          <p>{info.getValue() || "-"}</p>
          <p className="text-gray-500">
            {`${info.row.original.vehicle?.combinedMake || ""} ${info.row.original.vehicle?.combinedModel || ""}`.trim() || "-"}
          </p>
        </div>
      ),
    }),
    colHelper.accessor("status", {
      header: "Status",
      id: "status",
      sortingFn: "auto",
      cell: (info) => LeadStatus[info.getValue()],
    }),
    colHelper.accessor("ccid", {
      header: "CCID",
      id: "ccid",
      sortingFn: "auto",
      cell: (info) => info.getValue() || "-",
    }),
    colHelper.accessor("created", {
      header: "Created",
      id: "created",
      sortingFn: "auto",
      cell: (info) => formatCellDate(info.getValue()),
    }),
  ];

  return (
    <PagedTable
      columns={columns}
      url="/lead/deleted"
      queryLabel="Search customer, VRM, CCID or deleter"
      showTotal={true}
    />
  );
}
